import {getCookie, setCookie} from "@/utils/helperFunction";
import {COOKIE_HOST, IS_DEV, LANG} from "@/defaults";

export const UseLanguageStorage = () => {
  const getLang = () => {
    return getCookie('lang') || LANG
  }

  const setLang = (lang) => {
    const options = {}
    if(!IS_DEV) options.domain = COOKIE_HOST
    options.path = '/'
    setCookie('lang', lang, options)
  }



  return {
    getLang,
    setLang
  }
}
